<template>
  <div class="ListaRelatorioSelos">
    <table class="table">
      <thead class="table-header">
        <tr>
          <th scope="col">
            Número da OS
          </th>
          <th scope="col">
            Data da geração de selo
          </th>
          <th scope="col">
            Status do selo
          </th>
          <th scope="col">
            Status de envio ao TJSP
          </th>
          <th>
            Data de envio ao TJSP
          </th>
          <th>
            Ação
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(selo, i) in lista"
            :key="selo.selo_id">
          <th scope="row">
            {{ selo.numeroOs }}
          </th>
          <td>{{ handlerdatas(selo.created_at) }}</td>
          <td>{{ handlerSeloStatus(selo) }}</td>
          <td>{{ selo.status_selo }}</td>
          <td>{{ selo.data_envio_tj ? handlerdatas(selo.data_envio_tj) : '---' }}</td>
          <td>
            <b-dropdown id="acao"
                        variant="link" 
                        no-caret>
              <template #button-content>
                <icon-svg :style="{'color':'#1e4c89'}" 
                          icon="dotsHorizontalCircle"
                          class="icon-dots-horizontal" />
              </template>
              <b-dropdown-item @click="showModalDetalhes(selo)">
                Detalhes
              </b-dropdown-item>
              <b-dropdown-item @click="ajustarSelo(selo, acoes_selo.excluir)">
                Excluir selo
              </b-dropdown-item>
              <b-dropdown-item @click="ajustarSelo(selo, acoes_selo.cancelar)">
                Cancelar selo
              </b-dropdown-item>
              <b-dropdown-item 
                :disabled="!podeEnviarSelos([selo])"
                @click="$emit('enviar-selo', selo)">
                Enviar selo
              </b-dropdown-item>
            </b-dropdown>       
          </td>
        </tr>
      </tbody>
    </table>
        
    <b-modal v-if="modal.show"
             visible
             centered
             size="lg"
             hide-footer
             hide-header
             @hide="hideModalDetalhes()">
      <div>
        <header class="header-modal">
          Selo {{ detalhesSelo.num_selo }}
        </header>

        <div class="pt-3">
          <label>Detalhes do selo</label>
          <hr class="mt-n2">
          <div class="">
            <div class="row">
              <div class="col-1">
                <div class="font-weight-light">
                  <label for="OS">OS</label>
                </div>
                <div class="font-weight-bold">
                  {{ detalhesSelo.numeroOs }}
                </div>
              </div>

              <div class="col-4">
                <div class="font-weight-light">
                  <label for="DataHora">Data e hora da geração do selo</label>
                </div>
                <div class="font-weight-bold">
                  {{ detalhesSelo.created_at }}
                </div>
              </div>

              <div class="col-2">
                <div class="font-weight-light">
                  <label for="Status">Status</label>
                </div>
                <div class="font-weight-bold">
                  {{ handlerSeloStatus(detalhesSelo) }}
                </div>
              </div>



              <div v-if="detalhesSelo.data_cancelamento != null"
                   class="col-4">
                <div class="font-weight-light">
                  <label for="Status">Data e hora do cancelamento/exclusão</label>
                </div>
                <div class="font-weight-bold">
                  {{ detalhesSelo.data_cancelamento || '---' }}
                </div>
              </div>
            </div>

            <div class="col-4 mt-4 ml-n3">
              <div class="font-weight-light">
                <label for="Status">Usuário que gerou o selo</label>
              </div>
              <div class="font-weight-bold">
                {{ detalhesSelo.seloItemOs.ordemServicoItem.nome_usuario || '---' }}
              </div>
            </div>
          </div>
        </div>
        <div class="pt-3">
          <label>Envio ao TJ </label>
          <hr class="mt-n2">
          <div class="row">
            <div class="col-4">
              <div class="font-weight-light">
                <label for="OS">Data e hora envio ao TJ</label>
              </div>
              <div class="font-weight-bold">
                {{ detalhesSelo.data_envio_tj || '---' }}
              </div>
            </div>
            <div class="col">
              <div class="font-weight-light">
                <label for="OS">Status de envio ao TJ</label>
              </div>
              <div class="font-weight-bold">
                {{ detalhesSelo.status_selo || '---' }}
              </div>
            </div>
          </div>
        </div>

        <div class="pt-3">
          <label>Selo refificador </label>
          <hr class="mt-n2">
          <div class="row">
            <div class="col-4">
              <div class="font-weight-light">
                <label for="OS">Número do selo retificador</label>
              </div>
              <div class="font-weight-bold">
                {{ detalhesSelo.num_selo_retificador || '---' }}
              </div>
            </div>
          </div>
        </div>
      </div>  
      <hr>
      <footer class="d-flex justify-content-end mt-3 mb-3">
        <CustomButton text="voltar"
                      color="#eaeaea"
                      color-text="black"
                      @click="() => modal.show = false" />
      </footer> 
    </b-modal>
  </div>
</template>
  <script>
  import moment from 'moment'
  import CustomButton from '../CustomButton/CustomButton.vue'

  import HeaderBlue from '../SofiaRei/Headers/HeaderBlue.vue'

  // Services
  import SelosService from '@/services/Registros/SelosService'

  // Utils
  import { displayQuestion } from '@/utils/displayQuestion.js'
  
  export default {
    name: "ListaRelatorioSelos",
    components: {
      HeaderBlue,
      CustomButton
    },
    props: {
      propListaSelos: { type: Array, default: () =>([])},
      podeEnviarSelos: { type: Function, default: null }
    },
    data () { 
      return {
        numero_os: this.propListaSelos.numero,
        modal: {  
          show: false
        },
        lista: [],
        detalhesSelo: null,
        acoes_selo: {
          excluir: 'EXCLUIR',
          cancelar: 'CANCELAR',
        }
      }
    },
    watch: {
      propListaSelos () {
        this.init()
      }
    },
    mounted () {
      //console.log(this.propListaSelos)
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        const todosSelos = []
        this.propListaSelos.forEach(objeto => {
          const item = objeto.seloItemOs
          const os = item.ordemServicoItem.ordemServico
          todosSelos.push({...objeto, numeroOs: os.numero, nome_solicitante: os.nome_solicitante})        
        })
        this.lista = todosSelos
      },
      hideModalDetalhes () {
        this.modal.show = false
        // this.detalhesSelo.numero_selo = 0
        // this.detalhesSelo.data_hora_geracao = 0
        // this.detalhesSelo.status = 0
        // this.detalhesSelo.data_hora_exclusao = 0
        // //this.detalhesSelo.usuario_gerou = data.seloItemOs[0].selo.
        // this.detalhesSelo.data_envio_tj = 0
        // this.detalhesSelo.status_envio_tj = 0
        // this.detalhesSelo.selo_refiticador = 0

      },
      showModalDetalhes (selo) {
        this.modal.show = true
        selo.data_envio_tj = selo.data_envio_tj ? moment(selo.data_envio_tj).format('DD/MM/YYYY HH:mm') : null
        this.detalhesSelo = selo

      },
      handlerSeloStatus (selo) {
        if (selo.excluido_tj) return 'Excluido'
        if (selo.cancelado_tj) return 'Cancelado'
        return 'Ativo'
      },
      handlerdatas (value) {
        return moment(value).format('DD/MM/YYYY')
      },
      async ajustarSelo (selo, acao) {
        try {
          const questionText = 'Você realmente deseja excluir o selo? Exclusões após 72h úteis podem gerar sanções para seu cartório.'
          const question = await displayQuestion('Atenção', questionText, 'Sim', 'Não')
          if (!question) return

          const response = await SelosService.retificarSelo(selo.selo_id)
        
          if (response.status === 200) {
            objSwal.success.title = acao === 'CANCELAR' ? 'Sucesso ao cancelar o selo' : 'Sucesso ao excluir o selo'
            objSwal.success.text = ''
            await Swal.fire(objSwal.success)
          }
        } catch (error) {
          if (error.response) {
            displayMessage('error', 'Erro!', error.response.data.message || 'Erro ao processar a solicitação, tente novamente em alguns instantes.')
          }
        }
      }
    }
  }
  </script>
  <style lang="scss">

    .table-header {
      background: #01bfa5;
    }

    .header-modal {
      background: #eaeaea;
      padding: 20px 10px;
      font-size: 18px;
      font-weight: bold;
    }
    
    /* Estilização do botão de 'Ação' */
    .icon-dots-horizontal {
      height: 30px;
      width: 30px;
      padding: 0px;
      margin: 0px;
    }
  
    .dropdown-toggle {
      background: transparent !important;
      border: none !important;
      padding: 0 !important;
    }

    .dropdown-toggle::after {
      display: none !important;
    }

    .dropdown-toggle:focus, 
    .dropdown-toggle:focus-visible, 
    .btn:focus {
      outline: none !important;
      box-shadow: none !important;
    }
    /* Estilização do botão de 'Ação' */
  </style>
  